import React from 'react';
import { Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { PRIMARY_COLOR, PRIMARY_COLOR_HIGHLIGHT } from '../colors';
import { colorsModeUI } from '../modeUI';
import './index.css';

/**
 * Increase button
 * Parameters (Props)::
 * @param function increase
 * @param string mode
 */
export default class IncreaseButton extends React.PureComponent {
  constructor(props) {
    super(props);
    this.toggleHover = this.toggleHover.bind(this);
    this.state = {
      hover: false,
    };
  }

  /**
   * Toggle hover
   */
  toggleHover() {
    const { hover } = this.state;
    this.setState({ hover: !hover });
  }

  render() {
    const { increase, mode } = this.props;
    const { hover } = this.state;
    let styleButton = {
      color: hover ? PRIMARY_COLOR_HIGHLIGHT : PRIMARY_COLOR,
      cursor: hover ? 'pointer' : 'auto',
    };
    if (mode !== null) {
      const modeColors = colorsModeUI(mode);
      styleButton = {
        color: hover
          ? modeColors.ICON_PRIMARY_HOVER_COLOR
          : modeColors.ICON_PRIMARY_COLOR,
        cursor: hover ? 'pointer' : 'auto',
      };
    }
    return (
      <Icon
        circular
        name="add circle"
        onClick={increase}
        className="increase-button"
        style={styleButton}
        onMouseEnter={this.toggleHover}
        onMouseLeave={this.toggleHover}
        size="large"
      />
    );
  }
}

IncreaseButton.propTypes = {
  increase: PropTypes.func,
  mode: PropTypes.string,
};

IncreaseButton.defaultProps = {
  mode: null,
};
